import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-financial-late-cards',
  templateUrl: './financial-late-cards.component.html',
  styleUrls: ['./financial-late-cards.component.css']
})
export class FinancialLateCardsComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  dataSource: any = {
    chart: {
      numberPrefix: "R$ ",
      theme: "fusion",
      "paletteColors": "#FEC433",
      "maxBarHeight": "14",
      showValues: "1",
      placeValuesInside: "0"
    },
    data: []
  }

  loading: boolean = true;
  errorApi: boolean = false;
  loadingCartoesAtraso: boolean = true;
  message : string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    this.lateCardsInformation(item);
  }

  lateCardsInformation(item: any) {
    this.api.postOverdueCards(item.branch).subscribe(data => {
      try {
        this.dataSource.data = [];
        if(data.dataRow.length != 0){
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.card_name,
              'value': el.card_value,
              'valueBgColor': '#F9F9F9'
            })});
            this.errorApi = false;
        } else {
          this.errorApi = true;
          this.message = CONSTANTS.MESSAGES.DATA_NULL_OVERDUE_CARDS;
          this.formatErrorMensagem(CONSTANTS.MESSAGES.DATA_NULL_OVERDUE_CARDS);
        }
        this.loading = false;
      } catch (error : unknown) {
        this.loading = false;
        this.loadingCartoesAtraso = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_OVERDUE_CARDS;
      this.formatErrorMensagem(error.message);
    });
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-late-cards \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
